// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"05748e59","787":"2061e581"}[chunkId] + ".chunk.js";
};